import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IPSAuthenticationService, IPSTenantKeyService } from '@ips/common-angular';
import { TenantService } from '../../tenant.service';
import { VocabApiService } from '../../vocab/vocab.service';

@Component({
  selector: 'app-header',
  imports: [CommonModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit {
  availableTenants?: string[];
  firstName?: string;
  lastName?: string;
  displayName?: string;
  avatarUrl?: string;
  accountname?: string;

  constructor(
    private readonly router: Router,
    private readonly authz: IPSAuthenticationService,
    private readonly tenantKeyService: IPSTenantKeyService,
    private readonly tenantService: TenantService,
    private readonly vocabService: VocabApiService
  ) { }

  ngOnInit(): void {
    this.authz.currentUser.subscribe((user) => {
      this.tenantService.getAvailableTenants().subscribe((tenants) => {
        this.availableTenants = tenants;
      });
      let organizationValue = user?.definition?.attributes?.find(item => item?.key === 'organization');
      if(organizationValue?.value)
      {
        this.fetchUserOrganizationVocab(organizationValue?.value);
      }
      this.firstName = user.firstName;
      this.lastName = user.lastName;
      this.displayName = user.definition?.displayName;
      this.avatarUrl = user.avatarURL;
    });
  }

  toggleNav() {
    const sidenav = document.getElementById('sidenav')!;
    if (sidenav.style.width === '128px') {
      sidenav.style.width = '0';
    } else {
      sidenav.style.width = '128px';
    }
  }
  toggleProfileDropdown() {
    const profileDropdown = document.getElementById('profile-dropdown')!;
    if (profileDropdown.style.display === 'block') {
      profileDropdown.style.display = 'none';
    } else {
      profileDropdown.style.display = 'block';
    }
  }

  loadOrderInfoComponent(){
    this.router.navigate(['/home/place-order']);
  }

  changeTenant(tenant: string): void {
    this.tenantKeyService.setTenantKey(tenant);
  }

  logout() {
    this.authz.logout();
  }

  fetchUserOrganizationVocab(organizationValue: any){
    this.vocabService.getVocabData(['UserOrganization']).subscribe(data => {
      if (data) {
        const vocabUserData = data?.find(d => d.vocabularyName === 'UserOrganization');
        if (vocabUserData) {
         let vocabData = vocabUserData?.vocabularyItems?.find(item => item?.code === organizationValue);
         this.accountname = vocabData?.description;
        }
       }
    });
  }
}
